export default __webpack_public_path__ + "static/media/user.7c760551.svg";